// eslint-disable-next-line boundaries/no-unknown-files
import {
    Directive,
    inject,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { MsalAuthService } from '@app/services/msal-auth/msal-auth.service';
import { IRbacRoles } from '@app/types/rbac-roles';

@Directive({
    selector: '[appIsGranted]',
})
export class IsGrantedDirective implements OnInit {
    private msalAuthService = inject(MsalAuthService);
    private _templateRef = inject(TemplateRef);
    private _viewContainer = inject(ViewContainerRef);
    private _roleOrPermissions: IRbacRoles[] = [];
    @Input()
    set appIsGranted(roleOrPermissions: IRbacRoles[]) {
        this._roleOrPermissions = roleOrPermissions;
    }
    ngOnInit() {
        if (
            this.msalAuthService.isAccessRoleOrSupplyChainGranted(
                this._roleOrPermissions,
                [],
            )
        ) {
            this._viewContainer.clear();
            this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }
}
